module.exports = __webpack_public_path__ + "img/ai-btn.0b8487c7.png";